<template>
  <div class="Message">
    <div class="sent">
      {{ message.createdAt | dateformat("lll") }}
    </div>
    <div
      class="sender"
      :key="from.id"
      v-for="from of message.fromList">
      {{ from.firstName }} {{ from.lastName }}
    </div>
    <div class="body">
      {{ message.msg }}
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data: function() {
    return {
    }
  },

  props: {
    message: {
      type: Object,
      required: true,
    },
  },

  filters: {
    dateformat: (value, format) => {
      return moment(value).format(format);
    },
  },


  mounted() {},

  methods: {},

  computed: {},
}
</script>

<style lang="scss" scoped>
.Message {

      background-color: var(--pale-grey);
}
</style>

